export default __webpack_public_path__ + "1af30790df18476acf397d4bb79ebb1c.svg";